export function submitEditCustomReportCustomer()
{
    return({
        type:"SUBMIT_EDIT_CUSTOM_REPORT_DATA_CUSTOMER"
    })
}